import type { ReactNode } from 'react'

export const pageTitleClass = 'truncate text-base font-semibold text-slate-800 dark:text-slate-100'

/** One row: title (and its ? help), then filters, then actions pushed to the right; wraps on a narrow screen. */
export function Toolbar({
  title,
  help,
  level = 1,
  filters,
  actions,
  className = '',
}: {
  title?: ReactNode
  help?: ReactNode
  level?: 1 | 2
  filters?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  const Heading = level === 1 ? 'h1' : 'h2'
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-2 ${className}`}>
      {title && (
        <div className="flex min-w-0 items-center gap-1.5">
          <Heading className={pageTitleClass}>{title}</Heading>
          {help}
        </div>
      )}
      {filters && <div className="flex flex-wrap items-center gap-2">{filters}</div>}
      {actions && <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
